import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy, Medal } from "lucide-react";

export default function Leaderboard() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);

  const load = async () => {
    const { data } = await api.get(`/leaderboard?days=${days}&limit=20`);
    setData(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [days]);

  if (!data) return <div className="text-sm text-[#5c665a]">Loading…</div>;

  const cfg = data.config || {};
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-[#1a1c19] sm:text-3xl">Referrer Leaderboard</h1>
          <p className="text-sm text-[#5c665a]">Top referrers in the current window.</p>
        </div>
        <select className="admin-input max-w-[160px]" value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="lb-window-select">
          <option value={7}>Last 7 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
      </div>

      {cfg.leaderboard_enabled && (
        <div className="admin-card bg-gradient-to-br from-[#eaf8de] to-[#fff0f5]">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#5c665a]">Active streak bonus</div>
              <div className="mt-1 text-xl font-extrabold text-[#1a1c19]">
                Every {cfg.streak_threshold} referrals in {cfg.streak_window_days} days → <span className="text-[#ff3399]">KES {cfg.streak_bonus_kes}</span> bonus
              </div>
              <div className="text-xs text-[#5c665a]">Campaign: {cfg.campaign_name} · Adjust in Campaigns → Edit</div>
            </div>
            <Trophy className="h-10 w-10 text-[#ff3399]" />
          </div>
        </div>
      )}

      <div className="admin-card overflow-x-auto p-0">
        <table className="min-w-full text-sm">
          <thead className="bg-[#fafcfa] text-left text-xs uppercase tracking-wider text-[#5c665a]">
            <tr>
              <th className="px-4 py-3 w-14">#</th>
              <th className="px-4 py-3">Referrer</th>
              <th className="px-4 py-3">Phone</th>
              <th className="px-4 py-3 text-right">Successful</th>
              <th className="px-4 py-3 text-right">Earned (KES)</th>
              <th className="px-4 py-3">Streak</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#e2e8e2]" data-testid="lb-table">
            {data.rows.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-6 text-center text-[#5c665a]">No rewarded referrals in this window yet.</td></tr>
            ) : data.rows.map((r, i) => {
              const progress = cfg.streak_threshold ? (r.successful % cfg.streak_threshold) / cfg.streak_threshold : 0;
              return (
                <tr key={r.referrer_id} className={i === 0 ? "bg-[#fff0f5]" : ""}>
                  <td className="px-4 py-3 font-extrabold">{i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}</td>
                  <td className="px-4 py-3 font-semibold">{r.name}</td>
                  <td className="px-4 py-3 font-mono text-xs text-[#5c665a]">{r.phone_masked}</td>
                  <td className="px-4 py-3 text-right font-extrabold">{r.successful}</td>
                  <td className="px-4 py-3 text-right">KES {r.earned_kes?.toLocaleString()}</td>
                  <td className="px-4 py-3 w-40">
                    <div className="h-2 overflow-hidden rounded-full bg-[#e2e8e2]">
                      <div className="h-full rounded-full bg-gradient-to-r from-[#66cc33] to-[#ff3399]" style={{ width: `${progress * 100}%` }}></div>
                    </div>
                    <div className="mt-1 text-[10px] text-[#5c665a]">
                      {r.successful % cfg.streak_threshold}/{cfg.streak_threshold} to next bonus
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
